/** Chuỗi của chuông thông báo + báo về máy (web quầy). Tiếng Việt có dấu, câu ngắn. */
import { formatVnDateShort, formatVnTime, parseIsoStrict, toVnDateKey } from '@sapa/shared'
import type { LoaiTinQuay } from '../api.ts'
export const TB = {
  nut: 'Thông báo',
  tieuDe: 'Thông báo',
  dong: 'Đóng',
  moTa: 'Tin mới của tiệm trong 3 ngày qua',
  trong: 'Chưa có gì mới.',
  trongPhu: 'Tin mới của tiệm sẽ hiện ở đây.',
  loai: {
    lich_moi: 'Lịch mới qua Zalo',
    khach_huy: 'Khách huỷ lịch',
    xin_cho: 'Khách xin chờ chỗ',
    cho_duyet: 'Lịch mới chờ tiệm duyệt',
    chua_xac_nhan: 'Khách chưa xác nhận sẽ đến',
    khach_doi_gio: 'Khách đổi giờ hẹn',
    khach_nhan: 'Khách nhắn tiệm',
    cho_coc: 'Lịch mới chờ khách chuyển cọc',
    het_coc: 'Hết giờ chờ cọc, đã nhả chỗ',
    hoa_don_huy: 'Có hoá đơn bị huỷ',
    ket_lech: 'Két lệch khi chốt',
    het_duyet: 'Lịch chờ duyệt đã tự huỷ — bạn gọi lại khách nhé',
  } as Record<LoaiTinQuay, string>,
  /** 0065: "Thiếu 50.000đ" / "Dư 20.000đ" (két). */
  ketThieu: (tien: string) => `Thiếu ${tien}`,
  ketDu: (tien: string) => `Dư ${tien}`,
  trichLoi: (s: string) => `“${s}”`,
  /** Chuông gộp lời nhắn theo lịch: "Khách nhắn tiệm · 3 lời". */
  soLoi: (n: number) => `${n} lời`,
  /** Chuông theo chi nhánh (chỉ khi tiệm ≥ 2 chi nhánh): dòng đầu ngăn, báo nổi sau khi tự chuyển, nút quay lại, nhãn đọc màn hình. */
  moiOChiNhanh: (n: number, ten: string) => `${n} tin mới ở ${ten}`,
  daChuyenSang: (ten: string) => `Đã chuyển sang ${ten}`,
  veChiNhanh: (ten: string) => `Về ${ten}`,
  /** Tên đã bắt đầu bằng "Chi nhánh …" (mẫu hay gặp) thì đọc nguyên tên, không lặp "Chi nhánh Chi nhánh …". */
  nhanCnAria: (ten: string) => (/^chi nhánh\s/i.test(ten) ? ten : `Chi nhánh ${ten}`),
  moLich: 'Xem trên lịch',
  moCho: 'Xem danh sách chờ',
  vuaXong: 'vừa xong',
  phutTruoc: (n: number) => `${n}\u00A0phút trước`,
  gioTruoc: (n: number) => `${n}\u00A0giờ trước`,
  homQua: 'hôm qua',
  chuaTen: 'Khách chưa có tên',
  loiTai: 'Chưa tải được thông báo.',
  // Báo về máy (Web Push)
  dayTieuDe: 'Báo về máy này',
  dayMoTa: 'Máy vẫn kêu và hiện tin khi bạn không mở trang này.',
  dayBat: 'Bật báo về máy',
  dayTat: 'Tắt báo về máy',
  dayDangBat: 'Máy này đang nhận tin.',
  dayBiChan: 'Máy đang chặn thông báo. Mở cài đặt trình duyệt, cho phép thông báo rồi thử lại.',
  dayIos:
    'Trên iPhone/iPad: cài app lên màn hình chính trước (Chia sẻ → Thêm vào Màn hình chính), rồi mở từ biểu tượng đó.',
  dayKhongHoTro:
    'Trình duyệt này chưa nhận được thông báo. Dùng Chrome trên Android hoặc máy tính.',
  dayLoi: 'Chưa bật được. Bạn thử lại giúp nhé.',
  dayXong: 'Đã bật. Máy này sẽ báo khi có tin mới của tiệm.',
  dayDaTat: 'Đã tắt báo về máy này.',
  dangMo: 'Đang mở…',
} as const

/** "5 phút trước" / "2 giờ trước" / "hôm qua" / "Thứ Hai, 21/09 14:30" — tính theo mốc đồng hồ hiện tại. */
export function khiNao(lucIso: string, bayGioMs: number): string {
  const ms = bayGioMs - Date.parse(lucIso)
  const phut = Math.floor(ms / 60_000)
  if (phut < 1) return TB.vuaXong
  if (phut < 60) return TB.phutTruoc(phut)
  const gio = Math.floor(phut / 60)
  if (gio < 24) return TB.gioTruoc(gio)
  if (gio < 48) return TB.homQua
  const dt = parseIsoStrict(lucIso)
  return `${formatVnDateShort(toVnDateKey(dt))} ${formatVnTime(dt)}`
}
